var render = function render(_c,_vm){return _c('td',{staticClass:"d-none d-lg-table-cell"},[(_vm.props.track.artistId && !_vm.props.share)?[_c('router-link',{attrs:{"to":{name: 'artist', params: {id: _vm.props.track.artistId}}},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.props.track.artist)+" ")])]:[_vm._v(" "+_vm._s(_vm.props.track.artist)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }